import { User } from 'v2/core/entities/user';
import * as Sentry from '@sentry/react';
import { shouldIntegrateSentry } from '@modules/sentry/shouldIntegrateSentry';

export const setSentryTags = (user: User) => {
  if (!shouldIntegrateSentry()) {
    return;
  }

  Sentry.setTags({
    org: user?.tenant.name,
  });
};
